import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b0a07ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "align-items-center container d-flex flex-column" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Sobre el centro", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Historia")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Desde sus inicios, uno de nuestros objetivos ha sido no solo enseñar español, sino también generar el interés de los estudiantes por el idioma a través de la inmersión total en la cultura española, lo que hace que las clases sean increíblemente emocionantes e interesantes y les ayuda a conocer todas las peculiaridades de la sociedad española. y Cultura.")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Objetivo")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Nuestro principal objetivo es preservar la pureza de la lengua que se habla en la propia España, por ello todos nuestros profesores vinieron a Rusia para enseñarte la lengua castellana de referencia.")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Motivación")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Centro Picasso cree que la mejor manera de aprender un idioma es aprender en paralelo la cultura, la historia y la forma de pensar de la gente del país del idioma de destino. Realizamos periódicamente eventos culturales donde los alumnos de nuestro centro pueden poner en práctica sus conocimientos y conocer a los españoles, su cultura y forma de vida.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_card_header = _resolveComponent("b-card-header")!
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_card = _resolveComponent("b-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_Transition, {
      name: "slide-fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card, {
          "border-variant": "white",
          class: "m-4 porque-nosotros-card",
          style: {"min-width":"300px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_card_header, {
              style: {"font-size":"30px"},
              class: "text-center",
              "header-class": "porque-nosotros-card-header",
              "border-variant": "light",
              "header-bg-variant": "transparent"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_b_card_text, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "slide-fade-right",
      appear: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card, {
          "border-variant": "white",
          class: "m-4 porque-nosotros-card",
          style: {"min-width":"300px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_card_header, {
              style: {"font-size":"30px"},
              class: "text-center",
              "header-class": "porque-nosotros-card-header",
              "border-variant": "light",
              "header-bg-variant": "transparent"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_b_card_text, null, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "slide-fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card, {
          "border-variant": "white",
          class: "m-4 porque-nosotros-card",
          style: {"min-width":"300px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_card_header, {
              style: {"font-size":"30px"},
              class: "text-center",
              "header-class": "porque-nosotros-card-header",
              "border-variant": "light",
              "header-bg-variant": "transparent"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_b_card_text, null, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}